"use strict";
exports.__esModule = true;
exports.TileType = exports.TileFormat = void 0;
var TileFormat;
(function (TileFormat) {
    TileFormat["square"] = "square";
    TileFormat["rectangle"] = "rectangle";
})(TileFormat = exports.TileFormat || (exports.TileFormat = {}));
var TileType;
(function (TileType) {
    TileType["image"] = "image";
    TileType["gif"] = "gif";
    TileType["survey"] = "survey";
})(TileType = exports.TileType || (exports.TileType = {}));
//# sourceMappingURL=tile.js.map